import React from 'react';
import { useTranslation } from 'react-i18next';
import './ServicesCardsPrivateCloud.css';
import { services } from './ServicesDataPrivateCloud';
import { Timeline } from '../../../components/ui/timeline';
import ExpertiseSection from '../../HomePage/ExpertiseSectionHome/ExpertiseSectionHome';

const TimelinePrivateCloud: React.FC = () => {
  const { t } = useTranslation();

  const timelineItems = services.map((service, index) => ({
    date: "",
    title: t(`privateCloud.timeline.services.${index}.title`, service.title),
    description: t(`privateCloud.timeline.services.${index}.description`, service.description),
    icon: service.icon,
    features: service.features.map((feature, featureIndex) => ({
      text: t(`privateCloud.timeline.services.${index}.features.${featureIndex}`, feature.text)
    })).filter(f => f.text !== '')
  }));

  return (
    <div className="tw-container tw-mx-auto pb-16 bg-transparent tw-px-4 sm:px-4 md:px-4 lg:px-0 xl:px-0 2xl:px-0">      
    <div className="centered-title-dark-bg-approche ">
        <h2>{t('privateCloud.timeline.title', 'Notre approche')}</h2>
        <ExpertiseSection 
          translationKey="expertiseSection.timelineText"
          translationNamespace="privateCloud"
          defaultText="Pour garantir la réussite et la pertinence de votre solution de cloud privé, nous avons structuré notre accompagnement autour d'une méthodologie claire et éprouvée, déclinée en cinq étapes fondamentales."
        />
      </div>
      <Timeline items={timelineItems} />
    </div>
  );
};

export default TimelinePrivateCloud;